import { render, staticRenderFns } from "./ImWebimFaq.vue?vue&type=template&id=46b48bc7&scoped=true&"
import script from "./ImWebimFaq.vue?vue&type=script&lang=js&"
export * from "./ImWebimFaq.vue?vue&type=script&lang=js&"
import style0 from "./ImWebimFaq.vue?vue&type=style&index=0&id=46b48bc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b48bc7",
  null
  
)

export default component.exports